module.exports = __webpack_public_path__ + "media/images/do-not-crush-d676dd372abf15e808771c613f760c81.svg";